module.exports = {"410421001":"铁路街道","410421100":"城关镇","410421101":"周庄镇","410421102":"闹店镇","410421103":"石桥镇","410421104":"商酒务镇","410421105":"大营镇","410421106":"张八桥镇","410421107":"杨庄镇","410421108":"赵庄镇","410421200":"肖旗乡","410421202":"前营乡","410421203":"李庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410421.json
// module id = 1679
// module chunks = 0